export default __webpack_public_path__ + "static/media/leftArrow.ede893df.svg";